import React from "react";
import * as S from "./styles";
const Header = () => {
  return (
    <S.Container>
      <S.Header>
        <S.Title>Controle Financeiro</S.Title>
      </S.Header>
    </S.Container>
  );
};
export default Header;
